import { Component, OnInit,Input } from '@angular/core';
import { AppService } from '../app.service';
import { FormBuilder,Validators,FormControl } from '@angular/forms';
import { Event as RouterEvent,ActivatedRoute,Router,NavigationEnd} from '@angular/router';
import { googleNearResult } from '../google/nearplaceresult'; 
import { NgxSpinnerService } from 'ngx-spinner';
import { Common } from '../common/common';
import { environment } from "src/environments/environment";

declare var $:any;
declare var google;
declare var getBudgetWords:any; 
declare var $;
declare var gtag;
declare var fbq;

@Component({ 
  selector: 'app-listing',
  templateUrl: './propertyall.component.html',
  styleUrls: ['./propertyall.component.css']
})

export class PropertyallComponent implements OnInit {
  constructor(private fb:FormBuilder,private service:AppService,private route:ActivatedRoute,private router:Router,private nearPlace:googleNearResult,private spinner: NgxSpinnerService,private common:Common) { }
  
  alwarBounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(environment.norteastLatLongFirst, environment.norteastLatLongSecond),
    new google.maps.LatLng(environment.southwestLatLongFirst, environment.southwestLatLongSecond)
  );
  
  options={
    bounds:this.alwarBounds,
    componentRestrictions: { country: 'IN' },
    strictBounds:environment.strictBounds
  }

  p: number = 1;
  homesearch:any=JSON.parse(localStorage.getItem('homesearch'));
 
  property_type=new FormControl('');
  property_typee=new FormControl('');
  scrollDistance = 2; 
  throttle = 300;
  properties=[];
  offset:any=0;
  limit:any=100;
  notEmptyPost = true;
  notscrolly = true;

  propertyType:string="";
  propertyTypee:string="";
 
  ngOnInit() :void{ 
    if(environment.production){
    this.service.sendEvents("Completepropertyall", "propertyall", "PropertyAll");

    fbq('track', "CompletePropertyAll" , {
      content_type: "propertyall",
      content_title: this.router.url,
    });
  }

    this.propertyType=this.route.snapshot.paramMap.get('id');
    this.propertyTypee=this.route.snapshot.paramMap.get('id');
    var subcategory=this.route.snapshot.paramMap.get('subcategory');
    
    if(this.propertyType=='1'){
      this.property_type.setValue('2');
    }else if(this.propertyType=='2'){
      this.property_type.setValue('2');
    }else if(this.propertyType=='3'){
      this.property_type.setValue('2');
    }else if(this.propertyType=='4'){
      this.property_type.setValue('2');
    }

    if(this.propertyTypee=='1'){
      this.property_typee.setValue('1');
    }else if(this.propertyTypee=='2'){
      this.property_typee.setValue('2');
    }else if(this.propertyTypee=='3'){
      this.property_typee.setValue('3');
    }else if(this.propertyTypee=='4'){
      this.property_typee.setValue('4');
    }

   
  $(document).ready(function(){
    $(".filter-res-menu").click(function(){
      $(".filter").toggleClass("show-filter");
    });
  });
    
    this.uploadBudgetValue();  
    this.getAllProperty();

    this.property_type.valueChanges.subscribe(val => {
      if(this.property_type.value=='2'){
        this.router.navigateByUrl('/propertyall/buy');
      }else if(this.property_type.value=='1'){
        this.router.navigateByUrl('/propertyall/rent');
      }else if(this.property_type.value=='3'){
        this.router.navigateByUrl('/propertyall/pg');
      }   
      this.uploadBudgetValue();  
      
      this.searchForm.patchValue({"property_type":this.property_type.value});
    }); 

    this.searchForm.valueChanges.subscribe(val => {
      this.properties=[];
      this.offset=0;
      this.limit=100;
      this.notEmptyPost=true;
      this.notscrolly=true;
      this.getAllProperty();
    });   
    
    this.getAdvertisementBanner();
  }
  
  get getSearchText(){ 
   var searchData=JSON.parse(localStorage.getItem('homesearch'));
   
   var searchText="";
   var propertyText="";
   if(searchData.looking_type=='1'){
    propertyText+="Residential Properties ";
   }else if(searchData.looking_type=='2'){
    propertyText+="Commercial Properties  ";
   }else if(searchData.looking_type=='3'){
    propertyText+="Agriculture Properties ";
   }else if(searchData.looking_type=='4'){
    propertyText+="Industry Properties ";
   }



   
   if(propertyText=="" && searchData.location_sublocality!='' && searchData.location_sublocality!=null){
    searchText=this.propertyType+' in '+searchData.location_sublocality;
   }else if(propertyText!='' && searchData.location_sublocality!=''){
     searchText=propertyText+" in "+searchData.location_sublocality;
   }else if(propertyText!='' && searchData.location_sublocality==''){
     searchText=propertyText;
   }
   
   return "Property result";
  }

  advBanner:any="";
  getAdvertisementBanner(){
    this.service.get('/getPropertyListinAdv').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.advBanner=data[0];
        }
      },error=>{
        console.log('in error'); 
      }
    )
  }

  uploadBudgetValue(){ 
    if(this.property_type.value=='1'){
      this.getRentbudgetMinValue();   //load budget min price as per property type
    }else if(this.property_type.value=='2'){
      this.getBuybudgetMinValue();   //load budget min price as per property type
    }else if(this.property_type.value=='3'){
      this.getPgbudgetMinValue();   //load budget min price as per property type
    }
  }
  
  searchForm=this.fb.group({
    property_type:[this.property_type.value],
    location_lat:[this.homesearch.location_lat],
    location_long:[this.homesearch.location_long], 
    location:[this.homesearch.location],
    property_types:[this.homesearch.propertytype_subcat],
    noof_bhk:[''],
    sort_by:[''],
    pg_available:[''],
    pg_for:[this.homesearch.propertytype_subcat],
    min_budget:[''],
    max_budget:['']
  });

  get f() { return this.searchForm.controls; }
 
  handleAddressChange(event,type=''){   
    if(type=='mannual' && event.target.value==''){ 
      this.searchForm.patchValue({location_lat:'' });
      this.searchForm.patchValue({location_long:'' });   
    }else if(type=='address'){ 
      this.searchForm.patchValue({location_lat:event.geometry.location.lat() });
      this.searchForm.patchValue({location_long:event.geometry.location.lng() });
    }  
  }
 
  setPropertyTypeValue(){
    this.searchForm.patchValue({property_types:$('.property_type:checked').map(function() {return this.value;}).get().join(',')});
  }

   
  get setProopertyTypeArray(){ 
    if(this.f.property_types.value){
      return (this.f.property_types.value).split(','); 
    }else{
      return "";
    }

  }

  setNoOfBhkValue(){
    this.searchForm.patchValue({noof_bhk:$('.bhk_checked:checked').map(function() {return this.value;}).get().join(',')});
  }   

  setValueOFPg(){
    this.searchForm.patchValue({pg_for:$('.pg_for:checked').map(function() {return this.value;}).get().join(',')});
  }   
 
  setValueOfPgAvl(){
    this.searchForm.patchValue({pg_available:$('.pg_available:checked').map(function() {return this.value;}).get().join(',')});
  }   

  get getPgAvlValue(){ if(this.f.pg_available.value){ return (this.f.pg_available.value).split(','); }else{ return ""; }  }

  get getPgValue(){ if(this.f.pg_for.value){ return (this.f.pg_for.value).split(','); }else{ return ""; }  }

  location:string='Alwar, Rajasthan';
  location_lat:number=27.5898582;
  location_long:number=76.6167212;
  whatsNearByModalMap(lat,long,location){
    this.location=location;
    this.location_lat=lat;
    this.location_long=long;
    $('.nearestgoogleplace').trigger('click');
    this.nearByPlaceList('nearby','nearby');
    $('#mapModal').modal('toggle');
  }
 
  getBudgetWords(value:any){
    return getBudgetWords(value); 
  }

  budgetMin:any=[];
  getBuybudgetMinValue(){
    this.budgetMin=[];
    this.budgetMin.push('500000');
    this.budgetMin.push('1000000');
    this.budgetMin.push('1500000');
    this.budgetMin.push('2000000');
    this.budgetMin.push('2500000');
    this.budgetMin.push('3000000');
    this.budgetMin.push('4000000');
    this.budgetMin.push('5000000');
    this.budgetMin.push('6000000');
    this.budgetMin.push('7000000');
    this.budgetMin.push('8000000');
    this.budgetMin.push('9000000');
    this.budgetMin.push('10000000');
    this.budgetMin.push('20000000');
    this.budgetMin.push('30000000');
    this.budgetMin.push('40000000');
    this.budgetMin.push('50000000');
    this.budgetMin.push('60000000');
    this.budgetMin.push('70000000');
    this.budgetMin.push('80000000');
    this.budgetMin.push('90000000');
    this.budgetMin.push('100000000');
  }

  getRentbudgetMinValue(){
    this.budgetMin=[];
    this.budgetMin.push('1000');
    this.budgetMin.push('3000');
    this.budgetMin.push('5000');
    this.budgetMin.push('10000');
    this.budgetMin.push('15000');
    this.budgetMin.push('20000');
    this.budgetMin.push('25000');
    this.budgetMin.push('30000');
    this.budgetMin.push('40000');
    this.budgetMin.push('50000');
    this.budgetMin.push('60000');
    this.budgetMin.push('70000');
    this.budgetMin.push('80000');
    this.budgetMin.push('90000');
    this.budgetMin.push('100000');
    this.budgetMin.push('200000');
    this.budgetMin.push('300000');
    this.budgetMin.push('400000');
    this.budgetMin.push('500000');
    this.budgetMin.push('600000');
    this.budgetMin.push('700000');
    this.budgetMin.push('800000');
    this.budgetMin.push('900000');
    this.budgetMin.push('1000000');
  }

  getPgbudgetMinValue(){
    this.budgetMin=[];
    this.budgetMin.push('2000');
    this.budgetMin.push('3000');
    this.budgetMin.push('5000');
    this.budgetMin.push('10000');
    this.budgetMin.push('15000');
    this.budgetMin.push('20000');
    this.budgetMin.push('25000');
    this.budgetMin.push('30000');
    this.budgetMin.push('35000');
    this.budgetMin.push('40000');
    this.budgetMin.push('45000');
    this.budgetMin.push('50000');
  }

  budgetMax:any=[];
  getBudgetMaxValue(){ 
    this.budgetMax=[];
    if(this.budgetMin.length>0){
      for(var i=0;i<this.budgetMin.length;i++){
        if(this.f.min_budget.value=='' || (parseInt(this.budgetMin[i])>=parseInt(this.f.min_budget.value)))
        this.budgetMax.push(this.budgetMin[i]);
      }
    }

    return this.budgetMax;
  }

  
  listingLoader:boolean=false;
  getAllProperty(){ 
    if(this.searchForm.valid){
      this.notscrolly = false;
      if((this.property_type.value=='1' || this.property_type.value=='2')){
        this.getRentSellProperty();
      }else if(this.property_type.value=='3'){
        this.getPayingGuest();
      }
    }
  }

  getAllPropertyWithScroll(){ 
    if(this.searchForm.valid && this.notEmptyPost && this.notscrolly){
      this.notscrolly = false;
      if((this.property_type.value=='1' || this.property_type.value=='2')){
        this.getRentSellProperty('yes');
      }else if(this.property_type.value=='3'){
        this.getPayingGuest('yes');
      }
    }
  }
  
  getRentSellProperty(scroll='no'){
    if(scroll=='no'){
      this.listingLoader=true;
      this.service.loaderStatus = true; 
    }else{
      this.spinner.show();
    }
    var data=this.searchForm.value;
    data['property_type']=this.property_type.value;
    data['type']='Web';
    data['auth_token']=this.service.getAuthorizationToken();
    data['offset']=this.offset;
    data['limit']=this.limit;
    this.service.post('/propertyList', data).subscribe(
      data => { 
        if (data[0].error == '0') { 
          Array.prototype.push.apply(this.properties,data[0].result);
          this.offset+=this.limit;
          if(this.service.isLoggedIn()){
            var profileData=JSON.parse(localStorage.getItem('currentUser'));
            profileData.property_wishlistid=data[0].wishlist_id; 
            localStorage.setItem('currentUser',JSON.stringify(profileData));
          } 
        }else{
          this.notEmptyPost=false;
        }
        this.notscrolly = true;
        this.service.loaderStatus = false;
        this.listingLoader=false;
        this.spinner.hide();
      },
      error => {
        this.properties=[];
        this.notscrolly = true;
        this.service.loaderStatus = false;
        this.listingLoader=false;
        this.spinner.hide();
      }
    );
  }

  getPayingGuest(scroll='no'){
    if(scroll=='no'){
      this.service.loaderStatus = true;
      this.listingLoader=true;
    }else{
      this.spinner.show();
    }
    var data=this.searchForm.value;
    data['type']='Web';
    data['auth_token']=this.service.getAuthorizationToken();
    data['offset']=this.offset;
    data['limit']=this.limit;
    this.service.post('/getPayingGuestList', data).subscribe(
      data => {
        if (data[0].error == '0') {
          Array.prototype.push.apply(this.properties,data[0].result);
          this.offset+=this.limit;
          if(this.service.isLoggedIn()){
            var profileData=JSON.parse(localStorage.getItem('currentUser'));
            profileData.payingguest_wishlistid=data[0].wishlist_id; 
            localStorage.setItem('currentUser',JSON.stringify(profileData));
          } 
        }else{
          this.notEmptyPost=false;
        }
        this.service.loaderStatus = false;
        this.listingLoader=false;
        this.notscrolly = true;
        this.spinner.hide();
      },
      error => {
        this.notscrolly = true;
        this.service.loaderStatus = false;
        this.listingLoader=false;
        this.spinner.hide();
      }
    );
  }
 
  get chkPropertyWishlist(){ 
    if(this.service.isLoggedIn()){ 
      if(this.property_type.value=='1' || this.property_type.value=='2'){
        return this.service.getPropertyWishlistId.split(',');
      }else{
        return this.service.getPayingGuestWishlistId.split(',');
      }
    }else{
      return "";
    }
  }

  toggleProjectType1(){
    $('#flatoftype').toggleClass('type-class');
  }
 
  leadpropetyId:string="";
  leadTableName:string="";
  openLeadForm(property_type:any,id:any){ 
    this.leadpropetyId=id;
    
    if(property_type=='1' || property_type=='2'){
      this.leadTableName='tbl_property';
    }else{
      this.leadTableName='tbl_payingguest';
    }
  }

  addToWishlist(property_id,event){ 
    if(this.service.isLoggedIn()){
      this.listingLoader=true;
      this.service.post('/addPropertyWishlist',{"type":"Web","auth_token":this.service.getAuthorizationToken(),"property_type":this.property_type.value,"property_id":property_id}).subscribe(
        data=>{
          if(data[0].error=='0'){
            if(data[0].feature=='1'){
              event.srcElement.classList.add('shortlisted');
            }else{
              event.srcElement.classList.remove('shortlisted');
            } 
          }else{
            alert('something went wrong.please try again.');
          }
          this.listingLoader=false;
        },
        error=>{
          this.listingLoader=false;
        }
      )
    }else{
      $('#loginModal').modal('toggle');
    }

  }

  mapData:any;
  setmap(event:any){
    this.mapData=event; 
  }

  nearplaceList:any=[];
  findPlaces(types,radius,lat,long,map,className) {  
    var cur_location = new google.maps.LatLng(lat,long);

    // prepare request to Places
    var request = {
      location: cur_location,
      radius: radius,
      types: [types]
    };

    this.nearplaceList=[];
    var service = new google.maps.places.PlacesService(map); 
    service.nearbySearch(request, (results,status) => { 
      $('.'+className).css('display','block');
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        this.nearplaceList=results;
        $('.'+className).css('display','none');
      }else if (status == google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        $('.'+className).css('display','none');
      }else{ 
        $('.'+className).css('display','none');
      }
    }); 
  } 

  nearByPlaceList(catType,className){   
    if(catType=='nearby'){
      var type='bus_station,school,shopping_mall,hospital,atm,grocery_or_supermarket,pharmacy,restaurant,movie_theater,park,gym,petrol_station,bank';
      this.findPlaces(type,'200',this.location_lat,this.location_long,this.mapData,className); 
    }else{
      this.findPlaces(catType,'1000',this.location_lat,this.location_long,this.mapData,className); 
    }  
  } 

  resetFilters(){
    var homeSearchData=JSON.parse(localStorage.getItem('homesearch'));
    homeSearchData.propertytype_subcat="";
    localStorage.setItem('homesearch',JSON.stringify(homeSearchData));
    this.searchForm.patchValue({"property_types":""});
  }

  sharePost(type,url){ 
    this.common.sharePost(type,url);
  }

}
